import Picker from '@emoji-mart/react';
export interface BaseEmoji {
  id: string;
  name: string;
  native: string;
}

export interface EmojiPickerProps {
  onSelect?: (emoji: BaseEmoji) => void;
}

export function EmojiPicker({ onSelect }: EmojiPickerProps) {
  return (
    <Picker
      theme="light"
      maxFrequentRows={2}
      searchPosition="none"
      skinTonePosition="none"
      previewPosition="none"
      data={async () => {
        try {
          const response = await fetch('https://cdn.jsdelivr.net/npm/@emoji-mart/data');
          return response.json();
        } catch (error) {
          return {};
        }
      }}
      onEmojiSelect={onSelect}
    />
  );
}
